var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotWorking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 3.75C19.425 3.75 18.25 4.0625 17.2125 4.6125L15 11.25H18.75L15 23.75L16.25 12.5H12.5L14.425 5.7625C13.0875 4.5125 11.2625 3.75 9.375 3.75C5.525 3.75 2.5 6.775 2.5 10.625C2.5 15.7875 7.7 19.6 15 26.25C21.8375 20.075 27.5 15.925 27.5 10.625C27.5 6.775 24.475 3.75 20.625 3.75ZM12.8 20.9125C8.0625 16.675 5 13.75 5 10.625C5 8.175 6.925 6.25 9.375 6.25C10.1125 6.25 10.8625 6.4375 11.5375 6.775L9.1875 15H13.4625L12.8 20.9125ZM18.9125 19.4125L22.1125 8.75H18.475L19.2375 6.475C19.6875 6.325 20.1625 6.25 20.625 6.25C23.075 6.25 25 8.175 25 10.625C25 13.3875 22.475 16.1625 18.9125 19.4125Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotWorking);
export default __webpack_public_path__ + "static/media/Not Working.9cd59f324e6e950ef7d3a2d8e5c35d2e.svg";
export { ForwardRef as ReactComponent };